<template>
    <UserPageLayout @open-quiz-creator="openQuizCreator()" @clear-intro="onClearIntro()" ref="layout">
        <div id="my-quiz" class="mx-auto">
            <div
                :class="{
                    'mb-8': !quizzes.length,
                    'mb-5': quizzes.length
                }"
            >
                <VerifyEmail />

                <h1 class="system-text-color system-text-shadow text-center font-size-28 md:font-size-30 my-4">
                    <span v-if="typeQuiz == 'school'">{{ schoolName }} </span>{{ $t(`my_quiz_header_${typeQuiz}`) }}
                </h1>

                <h2 class="sr-only" hidden>for screen readers</h2>
                <h3 class="sr-only" hidden>for screen readers</h3>

                <p class="system-text-color system-text-shadow text-center font-size-18 md:font-size-20">
                    {{
                        $t(`my_quiz_description_${typeQuiz}`, {
                            count:
                                typeQuiz === 'whitelist' ? countWhitelist : typeQuiz === 'reports' ? countReport : count
                        })
                    }}
                </p>
                <div class="text-center py-5">
                    <div id="my-quiz-tab" class="btn-group">
                        <a
                            @click="fetchQuiz('normal')"
                            :class="{
                                active:
                                    !isShareActive &&
                                    !isApproveActive &&
                                    !isCompetitionActive &&
                                    !isSchoolQuizActive &&
                                    !isReportActive &&
                                    !isPartnerActive &&
                                    !isManageSchoolActive &&
                                    !isWhitelistActive,
                                'font-size-14 md:font-size-16': true
                            }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-list-alt"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_tab_my_quiz') }}</span>
                            </div>
                        </a>
                        <a
                            v-if="roleUser == 'creator' || roleUser == 'contributor'"
                            @click="fetchQuiz('approval')"
                            :class="{ active: isApproveActive, 'font-size-14 md:font-size-16': true }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-check-square"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_tab_approved') }}</span>
                            </div>
                        </a>
                        <a
                            @click="fetchQuiz('share')"
                            :class="{ active: isShareActive, 'font-size-14 md:font-size-16': true }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-share-alt"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_tab_shared') }}</span>
                            </div>
                        </a>
                        <a
                            v-if="isSchoolRole"
                            @click="fetchQuiz('school')"
                            :class="{ active: isSchoolQuizActive, 'font-size-14 md:font-size-16': true }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-chalkboard-teacher"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_school_quizes') }}</span>
                            </div>
                        </a>
                        <a
                            v-if="competitionQuizzes && competitionQuizzes.length"
                            @click="fetchQuiz('competitions')"
                            :class="{ active: isCompetitionActive, 'font-size-14 md:font-size-16': true }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-medal"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_tab_competitions') }}</span>
                            </div>
                        </a>
                        <a
                            @click="fetchQuiz('reports')"
                            :class="{ active: isReportActive, 'font-size-14 md:font-size-16': true }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-file-alt"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_tab_report') }}</span>
                            </div>
                        </a>
                        <a
                            v-if="isPartnerApproved && isPartner"
                            @click="fetchQuiz('partner')"
                            :class="{ active: isPartnerActive, 'font-size-14 md:font-size-16': true }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-handshake"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_tab_partner') }}</span>
                            </div>
                        </a>
                        <a
                            v-if="isSchoolAdmin && isTeacherPlus"
                            @click="fetchQuiz('manage_school')"
                            :class="{ active: isManageSchoolActive, 'font-size-14 md:font-size-16': true }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-chalkboard"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_tab_manage_school') }}</span>
                            </div>
                        </a>
                        <a
                            v-if="isTeacherRoles && !isUserInSchoolCustomAccess"
                            @click="fetchQuiz('whitelist')"
                            :class="{ active: isWhitelistActive, 'font-size-14 md:font-size-16': true }"
                        >
                            <div class="flex items-center">
                                <div class="sm:hidden font-size-24"><i class="fas fa-clipboard-list"></i></div>
                                <span class="hidden sm:block">{{ $t('my_quiz_tab_whitelist') }}</span>
                            </div>
                        </a>
                    </div>
                </div>
                <div v-if="isSchoolQuizActive && !isPlus" class="text-center">
                    <div class="text-verify-school px-5 py-1 system-border">
                        <div class="flex flex-wrap justify-center items-center">
                            <i class="fas fa-question-circle icon-color-yellow pr-1 font-size-20 mr-3"></i>
                        </div>
                        <div>
                            <span
                                v-html="$t(`my_quiz_header_upgrade_to_school_plan`, { role: basicRole })"
                                class="system-text-color system-text-shadow text-center font-size-14 md:font-size-14"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="
                    (!isShareActive &&
                        !isCompetitionActive &&
                        !isReportActive &&
                        !isPartnerActive &&
                        !isManageSchoolActive &&
                        !isWhitelistActive) ||
                    isSchoolQuizActive
                "
                @click="newQuiz('quiz')"
                class="xl:fixed new-quiz-box system-button-color system-button-text-color font-size-18 md:font-size-22 font-opensans uppercase text-center cursor-pointer xl:shadow-lg z-10"
            >
                <i class="fa fa-plus mr-2"></i>
                <span>{{ $t('my_quiz_button_new') }}</span>
            </div>

            <!-- filter school quizzes -->
            <div v-if="isSchoolQuizActive">
                <div
                    id="school-quiz-search-box"
                    class="flex flex-col md:flex-row justify-center items-center md:pb-6 md:mt-2 text-center pb-0 mb-5"
                >
                    <label for="search-school-quiz" class="sr-only">{{ $t('main_placeholder_search') }}</label>
                    <input
                        v-model="keyword"
                        @input="onSearchSchoolQuiz"
                        :placeholder="$t('main_placeholder_search')"
                        type="text"
                        name="table_search"
                        class="form-control form-control-search w-full text-center p-2 system-border"
                        aria-label="Search School Quiz"
                        id="search-school-quiz"
                    />
                    <Selection
                        v-model="grade"
                        @input="onSelectGrade"
                        :root="{ backgroundColor: 'rgba(255, 255, 255, .5)' }"
                        :select="{ fontSize: '16px', color: '#3f5c56', textAlignLast: 'center' }"
                        class="system-border"
                        id="grade-box"
                    >
                        <option class="text-center" value="" selected>
                            {{ $t('setting_header_class_grade') }}
                        </option>
                        <option :key="grade.label" v-for="grade in gradeList" :value="grade.value" class="text-left">
                            {{ $t(grade.translate_key) }}
                        </option>
                    </Selection>
                </div>
                <div id="taggable-subjects" class="text-center" v-cloak>
                    <ul class="list-reset md:mb-6">
                        <li
                            v-for="(item, index) in subjects"
                            @click="onClickSubjectHandler(item)"
                            :key="index"
                            :class="{
                                'inline-block px-3 py-1 rounded-full font-size-16 mb-3 taggable-subject system-text-color system-border': true,
                                active: subjects[index].active,
                                hidden: !subjects[index].status
                            }"
                        >
                            {{ subjects[index].label }}
                        </li>
                    </ul>
                </div>
            </div>

            <template v-if="quizzes.length && !isReportActive && !isPartnerActive">
                <div
                    v-if="!isApproveActive && !isCompetitionActive && !isSchoolQuizActive && !isShareActive"
                    @click="onEditQuiz"
                    class="system-text-color inline-block shadow-text-none ml-2 xl:ml-4 mb-4 cursor-pointer"
                    id="edit-quiz-item"
                >
                    <i class="fas fa-edit mr-1"></i>
                    <span v-if="!isEditQuiz">{{ $t('my_quiz_edit') }}</span>
                    <span v-else>{{ $t('my_quiz_close_edit') }}</span>
                </div>

                <div class="flex flex-wrap justify-content-center">
                    <div
                        v-for="quiz in quizzes"
                        :key="quiz._id.$oid"
                        class="w-1/2 sm:w-1/3 lg:w-1/4 xl:w-1/5 mb-2 sm:mb-4 xl:mb-8 px-1 sm:px-2 xl:px-4"
                    >
                        <QuizThumbnail
                            @open-quiz-preview="onOpenQuizPreview"
                            @open-share-popup="onOpenSharePopupHandler"
                            @delete-share-quiz="onDeleteShareQuiz"
                            @delete-my-quiz="onDeleteMyQuiz"
                            @open-quiz-creator="openQuizCreator"
                            @fetch-quiz="fetchQuiz('normal')"
                            :id="quiz._id.$oid"
                            :title="quiz.title"
                            :image="quiz.image"
                            :isFromMaster="quiz.isFromMaster"
                            :is-share="isShareActive"
                            :is-approve="isApproveActive"
                            :is-competitions="isCompetitionActive"
                            :is-school="isSchoolQuizActive"
                            :is-report="isReportActive"
                            :is-edit-quiz="isEditQuiz"
                            :shared-user="quiz.shared_user"
                            :quiz="quiz"
                            :type-quiz="typeQuiz"
                            ref="quizThumbnail"
                        />
                    </div>
                </div>
                <div v-if="isSchoolQuizActive" class="flex items-center justify-center">
                    <Paginator
                        @pagination-change="onPageChange"
                        :current-page="currentPage"
                        :page-count="pageCount"
                        :total-items="totalItems"
                    />
                </div>
            </template>

            <div v-if="isNoQuiz" class="flex flex-col justify-center items-center max-w-xl mx-auto my-12">
                <i class="fas fa-inbox system-text-color system-text-shadow font-size-40 md:font-size-56"></i>
                <h4
                    v-html="$t('school_quiz_not_data')"
                    class="system-text-color system-text-shadow text-center md:font-size-18 m-0 mt-4"
                ></h4>
            </div>
            <div
                v-if="isShareActive && !quizzes.length"
                class="flex flex-col justify-center items-center max-w-xl mx-auto my-12"
            >
                <i class="fas fa-people-arrows system-text-color system-text-shadow font-size-40 md:font-size-56"></i>
                <h4 class="system-text-color system-text-shadow text-center md:font-size-18 m-0 mt-4">
                    {{ $t('my_quiz_no_shared_quiz') }}
                </h4>
            </div>

            <div
                v-if="isCompetitionActive && !quizzes.length"
                class="flex flex-col justify-center items-center max-w-xl mx-auto"
            >
                <i class="fas fa-people-arrows system-text-color system-text-shadow font-size-40 md:font-size-56"></i>
                <h4 class="system-text-color system-text-shadow text-center md:font-size-18 m-0 mt-4">
                    {{ $t('my_quiz_no_competitions_quiz') }}
                </h4>
            </div>

            <div
                v-if="isApproveActive && !quizzes.length"
                class="flex flex-col justify-center items-center max-w-xl mx-auto"
            >
                <i class="fas fa-people-arrows system-text-color system-text-shadow font-size-40 md:font-size-56"></i>
                <h4 class="system-text-color system-text-shadow text-center md:font-size-18 m-0 mt-4">
                    {{ $t('my_quiz_no_approved_quiz') }}
                </h4>
            </div>

            <div v-if="isReportActive">
                <ReportThumbnail
                    :page="'my-quiz'"
                    @count-report="getCountReport"
                    @open-payment="setShowPaymentPopup"
                    ref="reportThumbnail"
                />
            </div>
            <div v-if="isPartnerActive">
                <PartnerSection />
            </div>

            <div v-if="isManageSchoolActive">
                <ManageSchoolSection @open-quiz-preview="onOpenQuizPreview" :register-slug="slug" />
            </div>

            <div v-if="isWhitelistActive">
                <WhitelistSection
                    @count-whitelist="getCountWhitelist"
                    @show-payment-popup="onShowPaymentPopupFromWhitelist"
                    ref="whitelistSection"
                />
            </div>
        </div>

        <QuizCreatorModal
            v-if="showQuizCreator"
            @close="onCloseCreatorModal"
            @fetch-quiz="fetchQuiz('normal', false)"
            @delete-quiz="deleteQuiz"
            @open-share-popup="onOpenSharePopupHandler"
            :quizzes-length="quizzes.length"
            ref="quizCreatorModal"
        />

        <SharePopup
            v-if="showSharePopup"
            @close="onSharePopupClosed"
            :id="shareQuizData.id"
            :title="shareQuizData.title"
            :image-path="shareQuizData.imagePath"
            :current-user="nameUser"
            :shared-user="shareQuizData.sharedUser"
        />
        <PaymentOneTimeOfferPopup v-if="showOneTimeOffer" @close="onCloseOneTimeOfferModal" ref="oneTimeOfferModal" />

        <PaymentPopup
            v-if="isShowPaymentPopup"
            @close="onClosePaymentPopup"
            @success="paymentSuccess"
            :payment-title="paymentModalTitle"
        />

        <QuizTypeSelectModal
            @close="onCloseSelectTypeModal"
            @select-quiz-type="onSelectQuizType"
            :open="showTypeSelectModal"
        />

        <PreviewQuestionModal v-if="isShowPreview" @close="onClosePreview" :url="previewUrl" />

        <WhitelistFormModal v-if="isShowWhitelistModal" @submit="onSubmitWhitelist" @close="onCloseWhitelistModal" />

        <MergeReportModal v-if="isShowMergeReportModal" @close="onCloseMergeReportModal" />
    </UserPageLayout>
</template>

<script>
import UserPageLayout from '@/layouts/UserPage'
import QuizThumbnail from '@/components/QuizThumbnail'
import { currentUser, getToken } from '@/lib/user'
import appConfig from '@/app.config.js'
import Request from '@/lib/request'
import { mapGetters } from 'vuex'
import Background from '@/lib/background.js'
import SharePopup from '@/components/SharePopup'
import VerifyEmail from '@/components/VerifyEmail'
import datalist from '@/mixins/datalist'
import helperMixin from '@/mixins/helper'
import { debounce } from 'lodash'
import ReportThumbnail from '@/components/ReportThumbnail'
import WhitelistSection from '@/components/WhitelistSection'
import PartnerSection from '@/components/PartnerSection'
import QuizCreatorModal from '@/components/quiz-creator/QuizCreatorModal.vue'
import popup from '@/lib/popup.js'
import {
    startIntroMyQuiz,
    startIntroSharedWithMe,
    startIntroSchoolQuizzes,
    startIntroCompetitionQuizzes,
    startIntroReports,
    startIntroAffiliate,
    startIntroManageSchool,
    startIntroWhitelist,
    startIntroApproval,
    startIntroQuizCreator,
    startIntroQuizItem,
    setSetting,
    getSetting
} from '@/lib/intro.js'
import IntroHint from '@/lib/intro.js'
import introJsData from '@/mixins/introjs-data'
import PaymentOneTimeOfferPopup from '@/components/PaymentOneTimeOfferPopup'
import PaymentPopup from '@/components/PaymentPopup'
import QuizTypeSelectModal from '@/components/quiz-creator/QuizTypeSelectModal.vue'
import randomize from 'randomatic'
import PreviewQuestionModal from '@/components/PreviewQuestionModal'
import WhitelistFormModal from '@/components/WhitelistFormModal'
import MergeReportModal from '@/components/merge-report/MergeReportModal'
import Paginator from '@/components/Paginator'
import ExampleQuiz from '@/mixins/example-quiz'
import ManageSchoolSection from '@/components/ManageSchoolSection'
import Selection from '@/components/v2/Selection'

export default {
    metaInfo() {
        return {
            title: this.$t('title_my_quiz')
        }
    },

    mixins: [datalist, helperMixin, introJsData, ExampleQuiz],

    components: {
        UserPageLayout,
        QuizThumbnail,
        SharePopup,
        VerifyEmail,
        ReportThumbnail,
        WhitelistSection,
        QuizCreatorModal,
        PaymentOneTimeOfferPopup,
        PartnerSection,
        PaymentPopup,
        QuizTypeSelectModal,
        PreviewQuestionModal,
        Paginator,
        ManageSchoolSection,
        WhitelistFormModal,
        MergeReportModal,
        Selection
    },

    data() {
        return {
            quizzes: [],
            isDataLoaded: false,
            showSharePopup: false,
            shareQuizData: null,
            nameUser: currentUser().name,
            roleUser: currentUser().role,
            schoolDistrict: currentUser().school_district,
            isPartner: currentUser().is_partner,
            isSchoolAdmin: false,
            isShareActive: false,
            isApproveActive: false,
            isCompetitionActive: false,
            isSchoolQuizActive: false,
            isManageSchoolActive: false,
            isWhitelistActive: false,
            typeQuiz: 'normal',
            slug: null,
            keyword: '',
            subjects: [],
            grade: '',
            subject: [],
            isNoQuiz: false,
            isReportActive: false,
            countReport: 0,
            countWhitelist: 0,
            schoolName: '',
            showQuizCreator: false,
            isEditQuiz: false,
            showTypeSelector: false,
            introHint: new IntroHint(),
            showOneTimeOffer: false,
            showOneTimeOfferCounter: 0,
            isShowedOneTimeOfferModal: false,
            isPartnerApproved: false,
            isPartnerActive: false,
            showTypeSelectModal: false,
            competitionQuizzes: [],
            isShowPreview: false,
            previewUrl: '',

            currentPage: 1,
            pageCount: 0,
            totalItems: 0
        }
    },

    created() {
        if (this.$route.query.create == 'true' && this.$route.query.type == 'normal') {
            this.openQuizCreator()
        }

        if (this.$route.params.id) {
            this.openQuizCreator(this.$route.params.id)
        }
    },

    async mounted() {
        await Promise.all([this.fetchSchool(), this.checkSchoolAdmin()])
        this.fetchQuizCompetition()
        this.fetchSettings()

        if (this.$route.query.type) {
            const type = this.$route.query.type

            if (type === 'school') {
                // Set keyword from URL if it exists
                if (this.$route.query.keyword) {
                    this.keyword = this.$route.query.keyword
                }

                // Set grade from URL if it exists
                if (this.$route.query.grade) {
                    this.grade = this.$route.query.grade
                }

                // Set subject from URL if it exists
                if (this.$route.query.subject) {
                    try {
                        const subjectNames = this.$route.query.subject.split(',')
                        this.subject = this.subjects.filter(s => subjectNames.includes(s.name))
                        // Update subjects active states
                        this.subjects = this.subjects.map(s => ({
                            ...s,
                            active: subjectNames.includes(s.name)
                        }))
                    } catch {
                        this.subject = []
                        this.subjects = this.subjects.map(s => ({
                            ...s,
                            active: false
                        }))
                    }
                }
            }

            this.fetchQuiz(type)
        } else {
            this.fetchQuiz('normal')
        }

        document.body.style.overflow = 'auto'

        if (this.fontpageSetting.background_type != null) {
            new Background({
                color: this.fontpageSetting.background_color,
                // image: this.fontpageSetting.background_image,
                type: this.fontpageSetting.background_type,
                navText: this.fontpageSetting.nav_text,
                useTheme: true
            })
        } else {
            new Background({
                color: appConfig.defaultBackgroundColor,
                useTheme: true
            })
        }

        this.$store.dispatch('validateSubscription')

        if (this.$route.query.newsletter) {
            this.$refs.layout.triggerOpenNewsletter()
        }

        document.addEventListener('click', e => {
            if (document.querySelector('.new-quiz-box')) {
                if (!document.querySelector('.new-quiz-box').contains(e.target)) {
                    this.showTypeSelector = false
                }
            }

            if (e.target.id == 'new-school-quiz') {
                this.newQuiz('quiz')
            }

            // If click on start live button && still not display one time offer modal
            if (
                e.target.id == 'start-live' &&
                !this.isShowedOneTimeOfferModal &&
                !this.isPaidUser &&
                !this.isTeacher &&
                this.shouldShowOneTimeOffer
            ) {
                e.preventDefault()
                this.introHint.removeHints()
                this.showOneTimeOffer = true
                this.isShowedOneTimeOfferModal = true
            }
        })

        this.$store.dispatch('getShowOneTimeOffer').then(res => {
            this.showOneTimeOfferCounter = res.data.data.counter
        })
    },

    watch: {
        keyword() {
            this.updateUrlParams()
        },

        grade() {
            this.updateUrlParams()
        },

        subject: {
            handler() {
                this.updateUrlParams()
            },
            deep: true
        },

        showOneTimeOffer(value) {
            if (value === false) {
                this.introHint.register(this.hintsQuizThumbnail)
            }
        },

        diffQuestionLength(newDiff) {
            const [prev, now] = newDiff
            // If user try to make first quiz
            // If they create 3 question and try to create 4th question
            // Show One Time Offer popup
            if (
                prev === 3 &&
                now === 4 &&
                !this.isShowedOneTimeOfferModal &&
                !this.isPaidUser &&
                this.isFirstQuiz &&
                this.shouldShowOneTimeOffer
            ) {
                this.showOneTimeOffer = true
                this.isShowedOneTimeOfferModal = true
            }
        },

        quizStatusUpdated(val) {
            this.quizzes = this.quizzes.map(quiz => {
                if (quiz._id.$oid === this.currentQuizId) {
                    quiz.status = val
                }
                return quiz
            })
        }
    },

    computed: {
        count() {
            if (this.isSchoolQuizActive) {
                return this.totalItems
            }

            return this.quizzes.length
        },

        countMsg() {
            return this.count > 1 ? 'quizzes/polls' : 'quiz/poll'
        },

        isFirstQuiz() {
            return this.quizzes.length === 1 && this.quizzes[0]._id.$oid === 'mock'
        },

        shouldShowOneTimeOffer() {
            return this.showOneTimeOfferCounter < appConfig.maxShowOneTimeOffer
        },

        isPaidUser() {
            return this.orderAbility.is_24hrs_access || this.orderAbility.has_subscribed
        },

        isSchoolRole() {
            return currentUser().role.includes('teacher') || currentUser().role.includes('student')
        },

        isPlus() {
            return currentUser().role === 'teacher_plus' || currentUser().role === 'student_plus'
        },

        isTeacher() {
            return currentUser().role.includes('teacher')
        },

        schoolRoleName() {
            if (currentUser().role.includes('teacher')) {
                return this.translate('school_role_teacher')
            }

            if (currentUser().role.includes('student')) {
                return this.translate('school_role_student')
            }

            return ''
        },

        basicRole() {
            if (currentUser().role === 'teacher') {
                return this.translate('school_role_teacher_basic')
            }

            if (currentUser().role === 'student') {
                return this.translate('school_role_student_basic')
            }

            return ''
        },

        isUserInSchoolCustomAccess() {
            return this.currentSchool && this.currentSchool.is_school_custom_access
        },

        ...mapGetters({
            fontpageSetting: 'getFrontPageSetting',
            orderAbility: 'orderAbility',
            diffQuestionLength: 'diffQuestionLength',
            paymentModalTitle: 'paymentModalTitle',
            paymentModalDescription: 'paymentModalDescription',
            isShowPaymentPopup: 'isShowPaymentPopup',
            isShowWhitelistModal: 'isShowWhitelistModal',
            isShowMergeReportModal: 'isShowMergeReportModal',
            quizStatusUpdated: 'getQuizStatus',
            currentQuizId: 'getQuizId'
        })
    },

    methods: {
        onClearIntro() {
            if (this.typeQuiz === 'normal') {
                setSetting('tour1', 0)

                let steps = [...this.stepTour1, ...this.stepTour3]

                if (this.quizzes.length >= 1) {
                    startIntroMyQuiz(steps, () => {
                        setSetting('tour3', 'completed')
                    })
                } else {
                    startIntroMyQuiz(this.stepTour1)
                }
            }

            if (this.isWhitelistActive) {
                setSetting('tour8', 0)

                startIntroWhitelist(this.stepTour8)
            }

            if (this.isShareActive) {
                setSetting('tour9', 0)

                startIntroSharedWithMe(this.stepTour9)
            }

            if (this.isSchoolQuizActive) {
                setSetting('tour10', 0)

                startIntroSchoolQuizzes(this.stepTour10)
            }

            if (this.isCompetitionActive) {
                setSetting('tour11', 0)

                startIntroCompetitionQuizzes(this.stepTour11)
            }

            if (this.isReportActive) {
                setSetting('tour12', 0)

                startIntroReports(this.stepTour12)
            }

            if (this.isPartnerActive) {
                setSetting('tour13', 0)

                startIntroAffiliate(this.stepTour13)
            }

            if (this.isManageSchoolActive) {
                setSetting('tour14', 0)

                startIntroManageSchool(this.stepTour14)
            }

            if (this.isApproveActive) {
                setSetting('tour15', 0)

                startIntroApproval(this.stepTour15)
            }
        },

        addExampleQuiz() {
            const quiz = {
                ...{ _id: { $oid: 'mock' } },
                ...{ user_id: currentUser().id },
                ...{ username: currentUser().username },
                ...{ email: currentUser().email },
                ...this.exampleQuiz()
            }

            if (currentUser().school_id) {
                quiz.school_id = currentUser().school_id
            }

            this.quizzes.push(quiz)
        },

        fetchQuiz(type, firstLoad = false, hasPagination = false) {
            const urlParams = new URL(window.location.href)
            this.isPartnerApproved = currentUser().is_approved

            const quizOid = urlParams.searchParams.get('quiz-oid')

            const currentType = this.$route.query.type || 'normal'

            if (type !== currentType && !firstLoad) {
                this.keyword = ''
                this.grade = ''
                this.subject = []
                this.subjects = this.subjects.map(s => ({ ...s, active: false }))
            }

            if (type === 'school') {
                // Keep existing search params for school type
                const existingParams = new URLSearchParams(window.location.search)
                urlParams.search = existingParams.toString()

                // Ensure type is set to school
                urlParams.searchParams.set('type', 'school')
            } else if (type !== 'partner') {
                urlParams.search = ''
            } else {
                if (!this.isPartner || !this.isPartnerApproved) {
                    type = 'normal'
                    urlParams.search = ''
                }
            }

            if (type === 'manage_school' && (!this.isSchoolAdmin || !this.isTeacherPlus)) {
                type = 'normal'
                urlParams.search = ''
            }

            urlParams.searchParams.set('type', type)
            urlParams.searchParams.set('rand', randomize('09', 5))

            if (quizOid) {
                urlParams.searchParams.set('quiz-oid', quizOid)
            }

            if (hasPagination) {
                urlParams.searchParams.set('page', this.currentPage)
            }

            // Handle pagination
            if (type === 'school' && !firstLoad && urlParams.searchParams.has('page')) {
                // Only use page from URL on initial load, not when filters change
                const page = parseInt(urlParams.searchParams.get('page'))
                if (!isNaN(page) && page > 0) {
                    this.currentPage = page
                }
            } else if (type === 'school' && firstLoad) {
                // On filter changes, ensure we're on page 1
                this.currentPage = 1
                if (urlParams.searchParams.has('page')) {
                    urlParams.searchParams.set('page', '1')
                }
            } else if (!hasPagination) {
                // For other types or when not using pagination, reset to page 1
                if (urlParams.searchParams.has('page')) {
                    urlParams.searchParams.delete('page')
                }
                this.currentPage = 1
            }

            if (type === 'manage_school' && this.isSchoolAdmin && this.isTeacherPlus) {
                const menu = ['users', 'quizzes', 'subjects', 'requests', 'settings']

                urlParams.searchParams.set(
                    'menu',
                    menu.includes(this.$route.query.menu) ? this.$route.query.menu : menu[0]
                )

                if (this.$route.query.page) {
                    urlParams.searchParams.set('page', this.$route.query.page)
                }
            }

            window.history.replaceState(null, null, urlParams.toString())

            this.typeQuiz = type

            if (typeof this.$router.currentRoute.query.id != 'undefined') {
                this.$router.push({
                    name: this.$router.currentRoute.name
                })
            }

            let request = new Request({
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            })

            const userId = currentUser().id
            let isShare = type === 'share' || (this.$route.params.share && typeof type === 'undefined')
            let isApproval = type === 'approval'
            let isCompetition = type === 'competitions'
            let isSchool = type === 'school'
            let isReport = type === 'reports'
            let isWhitelist = type === 'whitelist'
            let isPartner = type === 'partner'
            let isManageSchool = type === 'manage_school'
            let url = appConfig.api.yourQuiz.replace('__id__', userId)

            this.isShareActive = false
            this.isApproveActive = false
            this.typeQuiz = type
            this.isCompetitionActive = false
            this.isSchoolQuizActive = false
            this.isReportActive = false
            this.isWhitelistActive = false
            this.isPartnerActive = false
            this.isManageSchoolActive = false
            this.isNoQuiz = false
            this.quizzes = []

            if (isShare) {
                url = `${url}?share=true`
                this.isShareActive = true
            }

            if (isApproval) {
                url = `${url}?approved=true`
                this.isApproveActive = true
            }

            if (isCompetition) {
                url = appConfig.api.joinedSponsorQuiz.replace('__id__', userId)
                request = new Request({
                    headers: {
                        Authorization: `Bearer ${getToken()}`
                    }
                })
                this.isCompetitionActive = true
            }

            if (isSchool) {
                let params = {
                    keyword: this.keyword,
                    grade: this.grade,
                    subject: this.subject
                }

                url = appConfig.api.schoolMyQuizzes
                request = new Request({
                    headers: {
                        Authorization: `Bearer ${getToken()}`
                    },
                    params: { params, slug: this.slug, page: this.currentPage }
                })
                this.isSchoolQuizActive = true
            }

            if (isReport) {
                this.isReportActive = true
                return
            }

            if (isWhitelist && this.isTeacherRoles && !this.isUserInSchoolCustomAccess) {
                this.isWhitelistActive = true
                return
            }

            if (isPartner) {
                urlParams.searchParams.set('type_affiliate', this.$route.query.type_affiliate || 'point')
                window.history.replaceState(null, null, urlParams.toString())

                this.isPartnerActive = true
                return
            }

            if (isManageSchool && this.isSchoolAdmin) {
                this.isManageSchoolActive = true
                return
            }

            if (!firstLoad) {
                this.$store.commit('toggleMainLoader', true)
            }

            if (this.$route.query['quiz-oid']) {
                this.$store.commit('toggleMainLoader', true)
            }

            if (type != 'normal') {
                this.isEditQuiz = false
            }

            request
                .get(url)
                .then(res => {
                    this.quizzes = res.data.data

                    // If has pagination data
                    if (res.data.data.data) {
                        this.quizzes = res.data.data.data
                        this.currentPage = res.data.data.current_page
                        this.pageCount = res.data.data.page_count
                        this.totalItems = res.data.data.total
                    }

                    //show intro my quiz//
                    let steps = [...this.stepTour1, ...this.stepTour3]

                    if (type == 'normal' && !this.quizzes.length) {
                        this.addExampleQuiz()
                    }

                    if (type == 'normal') {
                        if (this.quizzes.length >= 1) {
                            setTimeout(() => {
                                startIntroMyQuiz(steps, () => {
                                    setSetting('tour3', 'completed')
                                })
                            }, 1000)
                        } else {
                            startIntroMyQuiz(this.stepTour1)
                        }
                    }

                    if (type == 'share') {
                        setTimeout(() => {
                            startIntroSharedWithMe(this.stepTour9)
                        }, 1000)
                    }

                    if (type == 'school') {
                        setTimeout(() => {
                            startIntroSchoolQuizzes(this.stepTour10)
                        }, 1000)
                    }

                    if (type == 'competitions') {
                        setTimeout(() => {
                            startIntroCompetitionQuizzes(this.stepTour11)
                        }, 1000)
                    }

                    if (type == 'approval') {
                        setTimeout(() => {
                            startIntroApproval(this.stepTour15)
                        }, 1000)
                    }

                    //show intro my quiz//

                    this.quizzes = this.quizzes.map(item => {
                        return {
                            ...item,
                            isFromMaster: typeof item.from_quiz_id !== 'undefined'
                        }
                    })

                    if (this.isSchoolQuizActive) {
                        this.isNoQuiz = this.quizzes.length === 0
                    }

                    this.isDataLoaded = true

                    if (!this.isReportActive) {
                        this.$store.commit('toggleMainLoader', false)
                    }

                    const urlString = window.location.href
                    const urlObject = new URL(urlString)
                    const id = urlObject.searchParams.get('quiz-oid')

                    this.$store.commit('toggleMainLoader', false)

                    if (id) {
                        this.$store.commit('toggleMainLoader', true)
                        const quizData = this.quizzes.find(e => e._id.$oid === id)
                        const quizIndex = this.quizzes.findIndex(e => e._id.$oid === id)
                        if (typeof quizData != 'undefined') {
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.$store.commit('toggleMainLoader', false)
                                    this.$refs.quizThumbnail[quizIndex].getQuizDataById(quizData)
                                }, 1000)
                            })
                        }
                    }
                })
                .catch(e => {
                    this.isDataLoaded = true
                    this.$store.commit('toggleMainLoader', true)

                    if (e.response && [403, 401].includes(e.response.status)) {
                        if (currentUser()) {
                            if (currentUser().provider === 'feide') {
                                location.href = '/skoler'
                                return
                            }

                            if (this.isSchoolRoles) {
                                location.href = '/school'
                                return
                            }
                        }

                        location.href = '/'
                    }
                })
        },

        countMyQuiz() {
            let request = new Request({
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            })

            const userId = currentUser().id

            let url = appConfig.api.yourQuiz.replace('__id__', userId)

            return new Promise((resolve, reject) => {
                request
                    .get(url)
                    .then(res => {
                        resolve(res.data.data.length)
                    })
                    .catch(reject)
            })
        },

        fetchQuizCompetition() {
            const userId = currentUser().id
            const url = appConfig.api.joinedSponsorQuiz.replace('__id__', userId)

            const request = new Request({
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            })

            request
                .get(url)
                .then(res => {
                    this.competitionQuizzes = res.data.data
                })
                .catch(() => {})
        },

        checkSchoolAdmin() {
            this.$store.commit('toggleMainLoader', true)

            const url = appConfig.api.checkSchoolAdmin

            const request = new Request({
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            })

            return new Promise((resolve, reject) => {
                if (!this.isSchoolRole) {
                    return resolve()
                }

                request
                    .get(url)
                    .then(res => {
                        resolve(res.data.data)
                        this.isSchoolAdmin = res.data.data.is_school_admin
                        this.$store.commit('toggleMainLoader', false)
                    })
                    .catch(() => {
                        this.$store.commit('toggleMainLoader', false)
                        reject()
                    })
            })
        },

        onOpenSharePopupHandler(data) {
            this.introHint.removeHints()
            this.showSharePopup = true
            this.shareQuizData = data
        },

        onSharePopupClosed() {
            // this.fetchQuiz()
            this.introHint.register(this.hintsQuizThumbnail)
            this.introHint.register(this.hintsQuestionList)

            this.showSharePopup = false
        },

        onClosePreview() {
            if (this.isTeacherPlus) {
                this.introHint.register(this.hintsQuizThumbnail)
            }

            this.isShowPreview = false
        },

        onCloseWhitelistModal() {
            this.$store.commit('setWhitelistModal', false)
        },

        onSubmitWhitelist(type) {
            if (this.isWhitelistActive) {
                if (type === 'edit') {
                    this.$refs.whitelistSection.fetchWhitelist()
                } else {
                    this.$refs.whitelistSection.setFirstPage()
                }
            }
        },

        onCloseMergeReportModal() {
            this.$store.commit('setMergeReportModal', false)
        },

        onDeleteShareQuiz(data) {
            const userId = currentUser().id
            let request = new Request()
            let url = appConfig.api.deleteSharedUser.replace('__id__', data.id)
            let formData = {
                shared_user: data.sharedUser.filter(item => {
                    return item !== userId
                })
            }

            this.$store.commit('toggleMainLoader', true)

            request
                .put(url, formData)
                .then(() => {
                    this.fetchQuiz('share')
                })
                .catch(() => {
                    this.$store.commit('toggleMainLoader', false)
                })
        },

        onDeleteMyQuiz(val) {
            if (this.quizzes.length == 1) {
                this.introHint.removeHints()
                this.isEditQuiz = false
            }

            if (val.id == 'mock') {
                this.quizzes = []
                return
            }

            let url = appConfig.api.deleteMyQuiz.replace('__id__', val.id)
            const request = new Request({
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            })

            this.$store.commit('toggleMainLoader', true)

            request
                .delete(url)
                .then(() => {
                    this.fetchQuiz('normal')

                    const url = new URL(window.location.href)

                    if (url.searchParams.has('quiz-oid')) {
                        url.searchParams.delete('quiz-oid')

                        window.history.replaceState(null, null, url.toString())
                    }

                    this.showQuizCreator = false
                })
                .catch(() => {
                    this.$store.commit('toggleMainLoader', false)
                })
        },

        goToNew() {
            this.$store.commit('resetQuiz')

            const url = this.$router.resolve({
                name: 'setting'
            })

            window.location.href = url.href
        },

        fetchSchool() {
            return new Promise((resolve, reject) => {
                const userId = currentUser().id

                if (!this.isSchoolRole) {
                    return resolve()
                }

                let request = new Request()

                let url = appConfig.api.getSchool.replace('__id__', userId)

                request
                    .get(url)
                    .then(res => {
                        this.slug = res.data.data.register_slug
                        this.subjects = res.data.data.subjects
                        this.schoolName = res.data.data.name

                        document.addEventListener('click', event => {
                            if (event.target.classList.contains('link-school')) {
                                event.preventDefault()

                                if (currentUser().role === 'student') {
                                    return
                                }

                                if (currentUser() && currentUser().provider === 'feide') {
                                    window.open(
                                        process.env.VUE_APP_NUXT_BASE_URL + '/skoler' + '#main-school-purchase',
                                        '_blank'
                                    )
                                    return
                                }

                                window.open(
                                    process.env.VUE_APP_NUXT_BASE_URL + '/school' + '#main-school-purchase',
                                    '_blank'
                                )
                            }

                            if (event.target.classList.contains('link-upgrade')) {
                                event.preventDefault()

                                if (currentUser().role === 'student') {
                                    return
                                }

                                this.$store.commit('openPaymentPopup', true)
                            }
                        })

                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            })
        },

        onSearchSchoolQuiz: debounce(function () {
            this.currentPage = 1 // Reset to page 1 when searching
            this.fetchQuiz('school', true, true)
        }, 500),

        onSelectGrade(val) {
            this.grade = val
            this.currentPage = 1 // Reset to page 1 when grade changes
            this.fetchQuiz('school', true, true)
        },

        onClickSubjectHandler(data) {
            this.subjects.forEach(subject => {
                if (data.name === subject.name) {
                    if (typeof subject.active == 'undefined' || !subject.active) {
                        return (subject.active = 1)
                    } else {
                        return (subject.active = 0)
                    }
                }
            })

            let dataSubjects = []

            for (let index in this.subjects) {
                if (this.subjects[index].active) {
                    dataSubjects.push(this.subjects[index])
                }
            }

            this.subject = dataSubjects
            this.currentPage = 1 // Reset to page 1 when subjects change
            this.fetchQuiz('school', true, true)
        },

        updateUrlParams() {
            const url = new URL(window.location)

            // Handle keyword
            if (this.keyword) {
                url.searchParams.set('keyword', this.keyword)
            } else {
                url.searchParams.delete('keyword')
            }

            // Handle grade
            if (this.grade) {
                url.searchParams.set('grade', this.grade)
            } else {
                url.searchParams.delete('grade')
            }

            // Handle subject - only store subject names in URL
            if (this.subject && this.subject.length > 0) {
                const subjectNames = this.subject.map(s => s.name)
                url.searchParams.set('subject', subjectNames.join(','))
            } else {
                url.searchParams.delete('subject')
            }

            // Update URL without adding to history
            window.history.replaceState({}, '', url)
        },

        getCountReport(count) {
            this.countReport = count
            this.isDataLoaded = false
        },

        getCountWhitelist(count) {
            this.countWhitelist = count
        },

        openQuizCreator(quizId) {
            // if (this.typeQuiz != 'normal') {
            //     window.location.href = this.$router.resolve({
            //         name: 'my-quiz',
            //         query: {
            //             type: 'normal',
            //             create: true
            //         }
            //     }).href

            //     return
            // }

            this.showQuizCreator = true

            this.$nextTick(() => {
                if (quizId) {
                    this.$refs.quizCreatorModal.editQuiz(quizId)
                } else {
                    if (getSetting('tour1') == 'completed') {
                        this.showTypeSelectModal = true
                    }
                }
            })
        },

        deleteQuiz(quizId) {
            popup.confirm(this.$t('my_quiz_alert_delete_quiz'), () => {
                this.introHint.removeHints()
                this.onDeleteMyQuiz({ id: quizId })
            })
        },

        async newQuiz(type) {
            const currentTab = this.typeQuiz
            let myQuizLength = this.quizzes.length

            if (currentTab === 'school') {
                this.$store.commit('toggleMainLoader', true)
                const countMyQuiz = await this.countMyQuiz()
                this.$store.commit('toggleMainLoader', false)

                myQuizLength = countMyQuiz
            }

            if (!this.isPaidUser && myQuizLength >= appConfig.maxFreeUserQuiz) {
                this.setShowPaymentPopup()
                return
            }

            this.showTypeSelector = false
            this.showQuizCreator = true

            this.$nextTick(() => {
                this.$refs.quizCreatorModal.selectQuizType(type, myQuizLength)
            })

            this.$store.commit('setCreateNewQuiz', true)

            //show intro quiz creator
            setTimeout(() => {
                startIntroQuizCreator(this.stepTour2)
            }, 700)
        },

        onEditQuiz() {
            this.isEditQuiz = !this.isEditQuiz
        },

        onCloseCreatorModal() {
            this.showQuizCreator = false

            if (this.quizzes.length >= 1) {
                setTimeout(() => {
                    startIntroQuizItem(this.stepTour3)
                }, 700)
            }
        },

        onCloseOneTimeOfferModal() {
            this.showOneTimeOffer = false
            this.$store.dispatch('checkUpdateShowOneTimeOffer').then(res => {
                this.showOneTimeOfferCounter = res.data.data.counter
            })
        },

        paymentSuccess() {
            this.$store.dispatch('findOrderAbility')

            if (this.$route.query.type) {
                this.fetchQuiz(this.$route.query.type)
            } else {
                this.fetchQuiz('normal')
            }
        },

        setShowPaymentPopup() {
            this.$store.commit('setPaymentModalTitleDescription', {
                title: this.$t('my_quiz_payment_modal_create_more_quiz_title'),
                description: this.$t('my_quiz_payment_modal_create_more_quiz_description')
            })

            this.$store.commit('openPaymentPopup', true)
        },

        onClosePaymentPopup() {
            this.$store.commit('openPaymentPopup', false)
        },

        onCloseSelectTypeModal() {
            this.showQuizCreator = false
            this.showTypeSelectModal = false
        },

        onSelectQuizType(type) {
            this.showQuizCreator = true

            this.$nextTick(() => {
                this.showTypeSelectModal = false
                this.$refs.quizCreatorModal.selectQuizType(type)
            })
        },

        onOpenQuizPreview(quizCode) {
            this.previewUrl = `${process.env.VUE_APP_NUXT_BASE_URL}/preview/${quizCode}/landing`
            this.isShowPreview = true
        },

        onPageChange(val) {
            const url = new URL(window.location.href)
            const type = url.searchParams.get('type') || 'normal'

            this.currentPage = val
            this.fetchQuiz(type, false, true)
        },

        fetchSettings() {
            this.$store.dispatch('getSystemSettings').then(res => {
                const setting = res.data.data
                window.defaultThemes = function () {
                    return setting.themes ? setting.themes.content : {}
                }

                const themeObj = {
                    question_text_color: setting.text_color.content,
                    question_shadow_color: setting.text_shadow_color.content,
                    button_text_color: setting.button_text_color.content,
                    button_color: setting.button_color.content,
                    ui_color: setting.ui_primary_color.content,
                    background_color: setting.background_color.content
                }

                this.$store.commit('setThemeSystemSettings', themeObj)
            })
        },

        onShowPaymentPopupFromWhitelist() {
            this.setShowPaymentPopup()
        }
    }
}
</script>

<style lang="scss" scoped>
.quiz-item .title {
    left: 0;
    bottom: 0;
    background-image: linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
    width: 100%;
    padding: 0.5rem;
    min-height: 25%;
    display: flex;
    align-items: flex-end;
    text-align: center;
    > * {
        width: 100%;
    }
}

.btn-group {
    border-radius: 0.5rem;
    overflow: hidden;
    display: inline-block;
    border: 2px solid var(--ui-primary-color);

    > a {
        color: var(--text-color);
        padding: 7px 15px;
        display: inline-block;
        cursor: pointer;

        span,
        i {
            text-shadow: var(--text-shadow) !important;
        }

        > span {
            transition: 0.3s;
        }

        > div {
            transition: transform 0.3s;
        }

        &:hover {
            > div {
                transform: translateY(-2px);
            }
        }

        &.active {
            background-color: var(--ui-primary-color);
            color: var(--ui-secondary-color);
        }
    }
}

.empty-container {
    border: 2px solid var(--ui-primary-color-alpha-50);
    border-radius: 6px;
}

@media (max-width: 575px) {
    .btn-group {
        display: flex;

        a {
            width: 100%;
            max-width: calc(100% / 3);
            padding: 7px 5px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.form-control {
    border: 0;
    font-size: 18px;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 5rem;
    min-width: 25%;
}

#school-quiz-search-box {
    gap: 1rem 0.5rem;

    #search-school-quiz {
        max-width: 480px;
        height: 40px;

        &::placeholder {
            color: #3f5c56;
            opacity: 1;
        }
    }

    #grade-box {
        min-width: 20%;
        max-width: 480px;
        height: 40px;
        border-radius: 5rem;
        background-color: rgba(255, 255, 255, 0.5);
    }
}

.taggable-subject {
    margin: 0.25rem 0.45rem;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.5);
    transition: 0.3s;
}

#taggable-subjects ul > li {
    margin: 0.25rem 0.45rem;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.5);
    transition: 0.3s;
}

#taggable-subjects ul > li:hover {
    background-color: rgba(255, 255, 255, 0.7);
}

#taggable-subjects ul > li.active {
    background-color: var(--ui-primary-color-alpha-20);
}

.no-quiz-school {
    font-size: 18px;
    color: var(--text-color);
    text-align: center;
}

.text-verify-school {
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.5);
    display: inline-flex;

    span {
        color: rgb(200, 0, 0);
        overflow: hidden;
        text-shadow: none;
    }

    .icon-color-yellow {
        color: #ff0700;
    }

    i {
        text-shadow: none;
    }
}

.new-quiz-box {
    width: fit-content;
    min-width: 180px;
    max-width: 100%;
    margin: 0 auto 1.25rem auto;
    border-radius: 0.25rem;
    color: var(--button-text-color);
    background-color: var(--button-background-color);
    font-weight: 700;
    padding: 0.5rem 1rem;
    transition: background-color 0.3s;

    &:hover {
        background-color: var(--button-background-color-hover);
    }

    @media screen and (min-width: 1200px) {
        bottom: 1.5rem;
        right: 1.5rem;
        margin: 0;
    }

    span,
    i {
        text-shadow: var(--text-shadow);
    }
}

#quiz-type-select {
    > .modal-content {
        max-width: 500px;
        height: auto !important;

        .modal-body {
            .type-select-box {
                column-gap: 1rem;
            }
        }
    }
}

#my-quiz {
    max-width: 1920px;
}
</style>
